import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {
  truBlueStatus,
  chemicalBaseTypeNames,
} from 'helpers/constants';
import {systemOptionsTags} from 'helpers/dataHelpers';
import {trublueMemberIDEnabled} from 'features';


class PoolTrashBinRecord extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    record: PropTypes.object.isRequired,
    dealer: PropTypes.object.isRequired,
  };

  render() {
    const {record, dealer} = this.props;
    const {formatMessage} = this.props.intl;
    const pool = record.pool;
    let poolLocation = systemOptionsTags[pool.typeID].location;
    let poolFinish = systemOptionsTags[pool.typeID].finish;
    const isCanada = dealer && dealer.country && dealer.country.toLowerCase() === 'ca';
    let volume = pool.volume.format(0, 3) + ' ' + formatMessage({id: isCanada ? 'quick-calcs.volume.litres' : 'quick-calcs.volume.gals'});
    let truBlue = dealer && dealer.isTruBlueEligible && pool.truBlueStatus !== truBlueStatus.Ineligible ?
      <i className={classNames('bl', 'bl-tru-blue-filled', {
        'blue': pool.truBlueStatus === truBlueStatus.Active,
        'grey': pool.truBlueStatus !== truBlueStatus.Active,
      })}/> : null;

    return (
      <div className="trashbin-record-content">
        <h4 className='trashbin-record-content__heading'><FormattedMessage id="general.account.details"/></h4>
        <div>
          <label>
            <strong>
              <FormattedMessage id="general.alexid"/>:
            </strong>
            <span className="value">{record.customer.accountNum}</span>
          </label>
        </div>
        <div>
          {record.customer.POSVendorID ?
            <label>
              <strong>
                <FormattedMessage id="general.posid" />:
              </strong>
              <span className="value">{record.customer.POSVendorID}</span>
            </label> :
         null}
        </div>
        <div>
          {trublueMemberIDEnabled && record.customer.truBlueMemberID &&
        record.customer.truBlueStatus === truBlueStatus.Active ?
          <label>
            <strong>
              <FormattedMessage id="general.trublue.memberID" />:
            </strong>
            <span className="value">{record.customer.truBlueMemberID}</span>
          </label> :
         null}
        </div>
        <div>
          <label>
            <strong>
              <FormattedMessage id="general.address"/>:
            </strong>
            <span className="value">
              {`${record.customer.address1} ${record.customer.address2 || ''} | ${
            record.customer.city || dealer.city || '--'
          } | ${record.customer.state || dealer.state} | ${
            record.customer.zip || dealer.zip || '--'
          }`} </span>
          </label>
        </div>
        <h4 className='trashbin-record-content__heading'><FormattedMessage id="general.pool.information"/></h4>
        <div className='system-summary' key={pool.ID}>
          <div className='system-summary__header'>
            <p>
              {pool.softSoakTRIO ? 'Trio ' : null}
              {chemicalBaseTypeNames(
                pool.typeID,
                pool.sanitizerType || 2,
                formatMessage
              )}
            </p>
            {pool.nickName ?
              <p>
                <label>
                  <FormattedMessage id="system.details.system.nickname" />
                </label>
                <span className="value">{pool.nickName}</span>
              </p> :
                 null}
          </div>

          <p>
            {poolLocation[pool.location] ? formatMessage({id: poolLocation[pool.location]}) : formatMessage({id: 'general.none'})}
            <span className='separator'> | </span>
            {volume}
            <span className='separator'> | </span>
            {poolFinish[pool.finish] ? formatMessage({id: poolFinish[pool.finish]}) : formatMessage({id: 'general.none'})}.
          </p>
          {truBlue ?
            <p>
              <label>
                <FormattedMessage id="general.trublue.status" />:
              </label>
              <span className="value"> {truBlue} {pool.truBlueStatus === truBlueStatus.Active ? formatMessage({id: 'general.active'}) : formatMessage({id: 'general.eligible'})}</span>
            </p> : null}
          <p>
            <label>
              <FormattedMessage id="general.last.analysis.date" />:
            </label>
            <span className="value">{pool.prevAnalysisDate ? moment(pool.prevAnalysisDate).format('ll') : formatMessage({id: 'general.never'})}</span>
          </p>
          <p>
            <label>
              <FormattedMessage id="system.widget.lifetime.analyses"/>
            </label>
            <span className="value">{pool.scanCount || 0}</span>
          </p>
        </div>
      </div>);
  }
}

export default injectIntl(PoolTrashBinRecord);
